<template>
	<div class="attribute">
		<div class="form-group">
			<label>Attribute Name</label>
			<input
				type="text"
				class="attribute__name input form-control"
				placeholder="Attribute Name"
				:class="{ 'is-error': attribute.name.trim() === '' }"
				:value="attribute.name"
				@input="onAttributeNameChange"
			/>
			<small
				class="text-secondary text-italic text-danger"
				v-if="attribute.name.trim() === ''"
			>
				Attribute Name cannot be empty
			</small>
		</div>
		<!-- <div class="form-group">
			<label>Attribute Options</label>
			<multiselect
				v-model="attribute.values"
				:placeholder="optionPlaceholder"
				:options="attribute.values"
				:hide-selected="true"
				:multiple="true"
				:taggable="true"
				:show-labels="false"
				:close-on-select="false"
				tag-placeholder="Press enter to insert option"
				tag-position="bottom"
				@tag="addOption">
			</multiselect>
			<div class="meta">{{ attribute.values }}</div>
		</div> -->
		<div class="form-group">
			<label>Attribute Options</label>
			<vue-tags-input
				v-model="variation"
				:tags="attribute.object_values"
				:allow-edit-tags="true"
				:placeholder="optionPlaceholder"
				@tags-changed="newTags => changeTags(newTags)"
				@before-adding-tag="onAddingTag"
				@before-deleting-tag="onDeletingTag"
			/>
		</div>
		<div class="text-right">
			<button
				class="btn btn-sm btn-icon btn-icon-danger btn-light"
				:class="{ 'cursor-not-allowed': isEditProduct }"
				@click="remove(index)"
				:disabled="isEditProduct"
			>
				<span
					><i class="material-icons">close</i
					><span>Remove Attribute</span></span
				>
			</button>
		</div>
	</div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { removeEmojis } from '@/lib/helper';

export default {
	components: {
		VueTagsInput,
	},
	name: 'productAttribute',
	props: {
		attribute: {
			type: Object,
			required: true,
		},
		index: {
			required: true,
		},
		// COMMENTED BY REQUEST
		// isEditProduct: {
		// 	type: Boolean,
		// 	default: false,
		// },
	},
	data() {
		return {
			variation: '',
			isEditProduct: false,
			// variations: this.attribute.values,
		};
	},
	methods: {
		remove(index) {
			this.$emit('remove', index);
		},
		addOption(value) {
			const option = value.trim().replace(/[\,\:\|]/gi, '');
			this.attribute.values.push(option);
		},
		onAttributeNameChange(event) {
			const value = event.target.value;
			const attrName = value.replace(/[^\w\s]/gi, '');
			this.attribute.name = attrName;
			this.$forceUpdate();
		},
		validateChangeTags(newTags) { // validate empty string after removing emojis
			let hasEmptyString = false; // case : user input emojis only, so after removing emojis the string become empty
			newTags.forEach((tag) => {
				const newText = removeEmojis(tag.text);
				if (newText === '') {
					hasEmptyString = true;
				}
			});
			return hasEmptyString;
		},
		changeTags(newTags) {
			const hasEmptyString = this.validateChangeTags(newTags);
			if (hasEmptyString) return; // reject if string is empty, clear input
			this.attribute.values = newTags.map(variation => removeEmojis(variation.text));
			this.attribute.object_values = newTags.map(variation => ({
				id: variation.id,
				text: removeEmojis(variation.text),
			}));
		},
		onAddingTag(obj) {
			obj.tag.id = this.$uuid.v4();
			obj.tag.text = removeEmojis(obj.tag.text);
			if (obj.tag.text === '') {
				this.variation = ''; // reject if string is empty, clear input
				return;
			}
			obj.addTag();
		},
		onDeletingTag(obj) {
			if (this.isEditProduct) {
				this.$notify({
					group: 'productCreator',
					title: 'Hapus Variant',
					text: 'Tidak dapat menghapus variasi pada produk yang sudah live.',
					type: 'error',
				});
			} else {
				obj.deleteTag();
			}
		},
	},
	computed: {
		optionPlaceholder() {
			return `Input '${this.attribute.name}' Option`;
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.attribute {
	padding: 1em;
	border-bottom: 1px solid $color__border;

	&:last-child {
		border-bottom: 0;
	}

	.form-group {
		margin-bottom: 1em;

		label {
			display: none;
		}
	}
}

.attribute-option {
	display: flex;
	justify-content: space-between;
}

.vue-tags-input {
	max-width: none !important;
	width: 100%;
}

.vue-tags-input .ti-input {
	border-radius: 8px !important;
	border-color: #d9dee2;
}

.vue-tags-input .ti-tag {
	position: relative;
	background: #41b883;
	color: #fff;
	border-radius: 5px;
}
</style>
